<template>

    <section class="membership_packages_wrp" :class="isLoggedIn ? 'package_list_login_wrp' : ''">
        <div class="membership_packages_bg_wrp"
            :class="selfUserInfo && selfUserInfo.pro_payment || selfUserInfo && selfUserInfo.auto_payment ? 'box_style_change' : ''">
            <router-link to="/" class="home_rdrtc_cross">
                <i aria-hidden="true" class="fa fa-times-circle-o mbl_cross"></i>
            </router-link>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12">
                        <h2 class="membership_packages_heading text-center">Upgrade your Digital Health Ecosystem</h2>
                        <h4 class="membership_packages_subheading text-center">Choose a plan that will enhance your AI
                            and Machine Learning research purposes</h4>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-4">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title text-center">Natural Package (Regular) </h5>
                                <h5 class="card-subtitle text-center">Basic Functionality </h5>
                                <h6 class="h1 text-white text-center mb-0">Free
                                </h6>
                            </div>
                            <div class="card-body">
                                <ul class="packages_features_list">
                                    <li><i class="fa fa-check"></i>View and connect with members</li>
                                    <li><i class="fa fa-check"></i>Attend hosted webinars </li>
                                    <li><i class="fa fa-check"></i>Access to Vista </li>
                                    <li><i class="fa fa-check"></i>Access to notes and scheduler in Workspace </li>
                                    <li><i class="fa fa-check"></i>Access to 1 GB Briefcase storage </li>
                                    <li><i class="fa fa-check"></i>One on one Chat with connected members </li>
                                    <li><i class="fa fa-check"></i>Can join video Meetings </li>
                                    <li><i class="fa fa-check"></i>Limited Access to AI and Data Dashboard</li>
                                    <li><i class="fa fa-check"></i>Access to Awerack – Research Papers Library (but
                                        can’t contribute with other members)</li>
                                </ul>
                                <template v-if="isLoggedIn">
                                    <template v-if="selfUserInfo">
                                        <template v-if="selfUserInfo && selfUserInfo.regular_payment">
                                            <template v-if="selfUserInfo && selfUserInfo.regular_payment">
                                                <button class="btn btn-primary btn-block active">Active</button>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title text-center">Supervised Package
                                    (Auto) </h5>
                                <h5 class="card-subtitle text-center">Elevated
                                    Functionality with
                                    Advanced Services</h5>
                                <h6 class="h1 text-white text-center mb-0">$12.99<span
                                        class="h6 text-white-50">(USD)/month</span></h6>
                            </div>
                            <div class="card-body">
                                <ul class="packages_features_list">
                                    <li><i class="fa fa-check"></i>Full access of Regular Package’s Features </li>
                                    <li><i class="fa fa-check"></i>Access to Video Call </li>
                                    <li><i class="fa fa-check"></i>Can create meetings with connected members </li>
                                    <!-- <li><i class="fa fa-check"></i>Can create core teams and add other members </li> -->
                                    <li><i class="fa fa-check"></i>Access to AI and Data Dashboard </li>
                                    <li><i class="fa fa-check"></i>Can create AI Models and Machine Learning Models
                                        through AI Dashboard</li>
                                    <li><i class="fa fa-check"></i>Create and host webinars </li>
                                    <li><i class="fa fa-check"></i>Access to Education Tab – Can engage in discussions
                                        on AI and Machine Learning with Global Members</li>
                                    <li><i class="fa fa-check"></i>Access to all Workspace features including Briefcase
                                        with 5.0 GB storage</li>
                                    <li><i class="fa fa-check"></i>Full access to Awerack including contributing with
                                        other members</li>
                                </ul>
                                <template v-if="isLoggedIn">
                                    <template v-if="selfUserInfo">
                                        <template v-if="selfUserInfo && !selfUserInfo.pro_payment">
                                            <template v-if="selfUserInfo && selfUserInfo.auto_payment">
                                                <button class="btn btn-primary btn-block active">Active</button>
                                                <!-- <div class="membership_cancel text-center"
                                                    v-if="!selfUserInfo.cancel_subscription">
                                                    <a href="javascript:void(0)" class="membership_cancel_txt"
                                                        @click="cancelMembershipPopupOpen">Cancel Subscription</a>
                                                </div> -->
                                            </template>
                                            <template v-else>
                                                <template
                                                    v-if="getPackageListDataResults && getPackageListDataResults.length > 0">
                                                    <router-link class="btn btn-block btn-primary"
                                                        :to="{ name: 'paymentCheckoutSupervisedPackage', query: { plan_id: getPackageListDataResults[0].plan_id } }">Subscribe Now</router-link>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title text-center">Neural Package
                                    (Pro)</h5>
                                <h5 class="card-subtitle text-center">Supreme Functionality, Advanced Services and
                                    Personal Assistance</h5>
                                <h6 class="h1 text-white text-center mb-0">
                                    $15.99<span class="h6 text-white-50">(USD)/month</span></h6>
                                <template
                                    v-if="selfUserInfo && !selfUserInfo.auto_payment && selfUserInfo && !selfUserInfo.pro_payment">
                                    <template v-if="selfUserInfo && selfUserInfo.trial_counter == '0'">
                                        <p class="seven_days_free_trial_alert">7 Days Free Trial</p>
                                    </template>
                                </template>
                            </div>
                            <div class="card-body">
                                <ul class="packages_features_list">
                                    <li><i class="fa fa-check"></i>Full access of Regular and Auto Package’s Features
                                        including Briefcase
                                        with 10.0 GB storage</li>
                                    <li><i class="fa fa-check"></i>Can create discussion boards under Education Tab</li>
                                    <li><i class="fa fa-check"></i>Will have personal assistance from both AI Engineers
                                        and Admin Team</li>
                                    <li><i class="fa fa-check"></i>Can book solo meetings with Admin Team members and AI
                                        Engineers for
                                        personalized tours/lessons</li>
                                    <li><i class="fa fa-check"></i>AI Engineers will create AI and Machine Learning
                                        models if asked for</li>
                                </ul>
                                <template v-if="isLoggedIn">
                                    <template v-if="selfUserInfo">
                                        <template v-if="selfUserInfo && selfUserInfo.pro_payment">
                                            <button class="btn btn-primary btn-block active">Active</button>
                                            <!-- <div class="membership_cancel text-center"
                                                v-if="!selfUserInfo.cancel_subscription">
                                                <a href="javascript:void(0)" class="membership_cancel_txt"
                                                    @click="cancelMembershipPopupOpen">Cancel Subscription</a>
                                            </div> -->
                                        </template>
                                        <template v-else>
                                            <template v-if="selfUserInfo && selfUserInfo.auto_payment">
                                                <template
                                                    v-if="getPackageListDataResults && getPackageListDataResults.length > 0">
                                                    <router-link class="btn btn-block btn-primary"
                                                        :to="{ name: 'paymentCheckoutUpgradeNowNeuralPackage', query: { plan_id: getPackageListDataResults[2].plan_id } }">Upgrade
                                                        for only 3$</router-link>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="selfUserInfo && selfUserInfo.trial_counter == '0'">
                                                    <template
                                                        v-if="getPackageListDataResults && getPackageListDataResults.length > 0">
                                                        <router-link class="btn btn-block btn-primary"
                                                            :to="{ name: 'freeTrialPaymentCheckout', query: { plan_id: getPackageListDataResults[1].plan_id } }">7-Days
                                                            Free Trial</router-link>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template
                                                        v-if="getPackageListDataResults && getPackageListDataResults.length > 0">
                                                        <router-link class="btn btn-block btn-primary"
                                                            :to="{ name: 'paymentCheckoutNeuralPackage', query: { plan_id: getPackageListDataResults[3].plan_id } }">Subscribe Now</router-link>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4" v-if="!isLoggedIn">
                    <div class="col-sm-12 text-center">
                        <router-link class="login_signup_btn_transparent" style="padding:10px 40px"
                            :to="{ name: 'signupPage' }">Sign
                            Up/Login</router-link>
                    </div>
                </div>
            </div>
        </div>
        <cancel-membership v-if="cancelMembershipPopupState"></cancel-membership>
    </section>
</template>

<script>
/* eslint-disable */

import { bus } from '@/main';
import cancelMembershipPopup from '@/components/private/package/cancel-membership-popup/'
import { mapGetters } from 'vuex';

const $ = window.jQuery = require('jquery');
export default {
    name: 'membership-packages-page',
    components: {
        'cancel-membership': cancelMembershipPopup
    },
    props: [],
    data() {
        return {
            isLoggedIn: null,
            selfUserInfo: null,
            getPackageListData: null,
            getPackageListDataResults: [],
            cancelMembershipPopupState: false
        }
    },
    computed: {
        ...mapGetters([
            'acUserDetailsStateGetters',
            'getAllPlansListGetters'
        ]),
        getUserDetailsAgainFun() {
            this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
            return;
        },
        checkUserLogin() {
            this.isLoggedIn = this.$store.getters.isAuthenticated
            return;
        },
        getPackageListDataFunc() {
            this.getPackageListData = this.$store.getters.getAllPlansListGetters
            return;
        },
        setInitialStatesOfPlanFunc() {
            if (this.getPackageListData) {
                this.getPackageListDataResults = this.getPackageListData.data
            }
            return;
        }
    },
    mounted() {
        this.checkUserLogin
        this.getPackageListDataFunc
        this.setInitialStatesOfPlanFunc
        if (this.isLoggedIn) {
            this.$store.dispatch('getAcUserDetailsFun')
        }
        bus.$on('cancelMembershipPopupStateBus', (data) => {
            this.cancelMembershipPopupState = data
        })
    },
    methods: {
        cancelMembershipPopupOpen() {
            this.cancelMembershipPopupState = true
            document.body.classList.add('body_right_scroll_remove')
        }
    },
    watch: {
        getUserDetailsAgainFun() {
            return this.$store.getters.acUserDetailsStateGetters;
        },
        checkUserLogin() {
            return this.$store.getters.isAuthenticated
        },
        getPackageListDataFunc() {
            return this.$store.getters.getAllPlansListGetters;
        },
        setInitialStatesOfPlanFunc() {
            if (this.getPackageListData) {
                this.getPackageListDataResults = this.getPackageListData.data
            }
            return;
        }
    },
    beforeCreate: function () {
        $('body').addClass('left_sidebaar_disabled_for_page')
        $('body').addClass('public_page_for_wrp_img')
    },
    beforeRouteLeave: function (to, from, next) {
        $('body').removeClass('left_sidebaar_disabled_for_page')
        $('body').removeClass('public_page_for_wrp_img')
        $(window).scrollTop(0);
        next();
    },
}
</script>

<style lang="scss" scoped>
@import url('../../../assets/fonts/acetone/style.css');
.membership_packages_wrp {
    min-height: 100dvh;
    padding-top: 65px;
    color: #FFFDD0;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color emoji;
    .membership_packages_bg_wrp{
        background: rgba(0, 0, 0, 0.92);
        padding:30px 15px;
        position: relative;
        @media only screen and (max-width:1023px){
            padding:20px 10px;
        }
    }
    .membership_packages_heading{font-family:'origin_tech_demoregular';}
    .card{
        background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
        // background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 43, 170, 0.6) 50%, rgba(5, 2, 111, 0.7) 50%, rgba(64, 64, 77, 0.6) 100%);
        min-height: 770px;
        @media only screen and (max-width:1392px){
            min-height: 815px;
        }
        @media only screen and (max-width:767px){
            margin-top:10px;
        }
    }
    .card-header {
        min-height: 200px;
        background: none;
        border-bottom: 1px solid rgba(161, 155, 155, 0.13);
        .card-title{
        font-size: 26px;
        color: #c4ffff;
        margin-bottom:20px;
        }
        .card-subtitle {
            font-size: 20px;
            margin-bottom: 15px;
            color: #d981b3;
        }
    }
    .packages_features_list {
        li {
            position: relative;
            padding-left: 30px;
            margin-bottom: 15px;
            font-size: 18px;
            &:last-child{margin-bottom:0px;}
            .fa{position: absolute;left:0px;top:4px;}
        }
    }
    .btn-primary{    
        background: rgba(135, 206, 250, 0.3);
        color: #ffffff;
        border:1px solid rgba(135, 206, 250, 0.6);
        padding:10px;
        font-size:20px;
        box-shadow:none !important;
        &:hover{background:#FFFFC5;color:#000000;border-color: #FFFFC5;color: #22292f;}
        &.active{    
            background: rgba(39, 155, 55, 0.3);
            color: #ecedc2;
            cursor: default;
            border: 1px solid rgba(39, 155, 55, 0.6);
            }
    }
    .login_signup_btn_transparent{
        font-family: 'ACETONE';
        background: none !important;
        border: 2px solid #ffe400 !important;
        color: #ffe400 !important;
        text-transform: uppercase;
        font-size: 28px;
        padding: 5px 8px;
        line-height: 1;
        height: auto;
        min-width: 110px;
        display: inline-block;
        border-radius: 6px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        text-decoration: none !important;
        &:hover{    
            background: #ffe400 !important;
            color: #000000 !important;
        }
    }
    .membership_cancel {
        margin-top: 15px;
        .membership_cancel_txt{
             text-decoration: none;
            cursor: pointer;
            padding: 5px 10px 8px;
            color: #e4002b;
            font-size: 16px;
            background-color: rgba(31, 31, 31, 0.5);
            border-radius: 4px;
            line-height: 1;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            border: 1px solid rgba(174, 182, 184, 0.1);
            overflow: hidden;
            display: inline-block;
            font-weight: 500;
            position: relative;
            &::before {
                content: "";
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(120deg,
                        transparent,
                        rgba(255, 255, 255, 0.2),
                        transparent);
                left: -100%;
                transition: all 0.65s ease-in-out;
            }

            &:hover {
                color:#ffd400;

                &::before {
                    left: 100%;
                }
            }
        }
    }
    &.package_list_login_wrp{
        .packages_features_list {
            min-height: 550px; 
            margin-bottom:0px;
        }
        .card{min-height:875px;}
        .card-header{min-height:220px;}
        @media only screen and (max-width:1392px){
         .packages_features_list{min-height: 600px;}
         .card{min-height:905px;}
        }
        .box_style_change{
            .card{
                min-height:880px;
                @media only screen and (max-width:1390px){
                    min-height:930px;
                }
                .card-header{
                    min-height: 185px;
                }
            }
        }
        @media only screen and (max-width:767px){
         .packages_features_list{min-height: inherit !important;margin-bottom: 20px !important;}
         .card{min-height:inherit !important;}
        }
    }
    .seven_days_free_trial_alert {
        margin: 0;
        font-size: 20px;
        text-align: center;
        margin-top: 15px;
        line-height: 1;
        color: #ffec1e;
        font-weight: 500;
    }

    .home_rdrtc_cross{
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        z-index: 100;
        padding: 4px 10px;
        color: #e4002b;
        font-size: 28px;
        background-color: rgba(31, 31, 31, 0.5);
        border-radius: 5px;
        line-height: 1;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid rgba(174, 182, 184, 0.1);
        overflow: hidden;
        display: inline-block;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(120deg,
                    transparent,
                    rgba(255, 255, 255, 0.2),
                    transparent);
            left: -100%;
            transition: all 0.65s ease-in-out;
        }

        &:hover {
            box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;
            color:#ffd400;

            &::before {
                left: 100%;
            }
        }
    }
}
</style>